<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <AccordionPrimary :accordion="fields.accordion" label="Accordion" />
        </div>

        <div class="mb-4">
          <label class="label-input">Layout Card</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model.number="fields.layout.gap"
                  type="number"
                  label="Gap"
                  min="0"
                  suffix="px"
                  hide-details
                  class="mb-0 mt-0"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox v-model="fields.layout.centerY" label="Center vertical" hide-details />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Content</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Image</label>
          <div class="group-item">
            <div class="mb-4">
              <v-select
                :value="fields.rightCard.order"
                :items="[
                  {
                    text: 'Left',
                    value: 1,
                  },
                  {
                    text: 'Right',
                    value: 2,
                  },
                ]"
                @change="handleChangePosition"
                label="Position"
                hide-details
              />
            </div>
            <div class="mb-4">
              <div>
                <v-checkbox
                  v-model="fields.layout.useCustomWidthImg"
                  label="Use custom image width"
                  hide-details
                  class="mb-2"
                />
                <div v-if="fields.layout.useCustomWidthImg">
                  <v-text-field
                    type="number"
                    v-model.number="fields.layout.widthImg"
                    label="Image width"
                    hide-details
                    suffix="%"
                  />
                </div>
              </div>
            </div>
            <div>
              <UploadImage
                @callback="handleUploadImage"
                :image="{ imageSrc: fields.image.src }"
                :height="`180`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveImage"
              />
            </div>
          </div>
        </div>

        <div class="mb-4">
          <DividerPrimary :divider="fields.divider" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import AccordionPrimary from './common/accordion-primary.vue';
import DividerPrimary from './common/divider-primary.vue';

export default {
  name: 'gatorz-frame-specs-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    AccordionPrimary,
    DividerPrimary,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Gatorz Frame Specs',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        accordion: {
          open: false,
          title: '<h2><strong>FRAME SPECS</strong></h2>',
          backgroundColor: '#ffffff',
          color: '#000000',
          icon: {
            type: 'plus-minus',
            position: 'right',
            show: true,
          },
        },
        divider: {
          show: true,
          maxWidth: 9999,
          height: 3,
          backgroundColor: '#C3C3C3',
          align: 'center',
        },
        layout: {
          useCustomWidthImg: true,
          widthImg: 50,
          gap: 32,
          centerY: true,
        },
        leftCard: {
          order: 2,
        },
        rightCard: {
          order: 1,
        },
        content:
          '<h2 style="text-align: center;"><strong>WARHAWK</strong></h2><p style="text-align: center;">&nbsp;</p><p><strong>WARHAWK FRAME MEASUREMENTS</strong></p><p>Frame width: <strong>143mm</strong></p><p>Lens height: <strong>39mm</strong></p><p>Lens width: <strong>66mm</strong></p><p>Bridge Width: <strong>15mm</strong></p><p>Temple length: <strong>118mm</strong></p><p>Base Curve: <strong>8x4</strong></p>',
        image: {
          src: '',
          alt: 'Warhawk frame specs',
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        accordion: {
          ...this.fields.accordion,
          ...(extract.accordion || {}),
          icon: {
            ...this.fields.accordion.icon,
            ...((extract.accordion || {}).icon || {}),
          },
        },
        divider: { ...this.fields.divider, ...(extract.divider || {}) },
        layout: { ...this.fields.layout, ...(extract.layout || {}) },
        leftCard: { ...this.fields.leftCard, ...(extract.leftCard || {}) },
        rightCard: { ...this.fields.rightCard, ...(extract.rightCard || {}) },
        image: { ...this.fields.image, ...(extract.image || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionGatorzFrameSpecs(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields.image.src = obj.imageSrc || '';
    },
    handleRemoveImage() {
      this.fields.image.src = '';
    },
    handleChangePosition(value) {
      this.fields.rightCard.order = value;
      this.fields.leftCard.order = value === 1 ? 2 : 1;
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
